export default __webpack_public_path__ + "static/media/gallery_02.ef386ac1.jpg";